import React, {Component} from 'react';
import {connect} from 'react-redux';
import {followStrategy, unfollowStrategy} from 'actions/followingStrategies';
import {setFollowingPicks} from 'actions/followingPicks';
import {checkStrategyIsFollowing} from 'selectors/followingStrategies';
import {
  followStrategyRequest,
  getPicksRequest,
  getPaymentLinkRequest,
  getUserPaymentsRequest,
  unfollowStrategyRequest,
} from 'requests';
import {strategyPrice} from 'utils/mixins';
import {getUserPayments} from 'selectors/user';
import classnames from 'classnames';
import {setUserPayments} from 'actions/user';
import {FollowIcon, UnfollowIcon} from './icons';
import './followStrategy.scss';

class FollowStrategy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  handleClick = async () => {
    const {isFollowing, strategy, payments} = this.props;
    const isPremium = strategy.price > 0;
    const isPurchased = payments.some(
      str => str.strategyId === (strategy.strategyId ? strategy.strategyId : strategy.id),
    );
    this.setState({loading: true});
    if (isFollowing) {
      await this.unfollowStrategy(strategy);
    } else if (isPremium && !isPurchased) {
      await this.followAction();
    } else if ((isPremium && isPurchased) || !isFollowing) {
      await this.followStrategy(strategy);
    }
    this.setState({loading: false});
  };

  async followStrategy() {
    try {
      this.setState({loading: true});
      this.props.onSubsAmountIncrement && this.props.onSubsAmountIncrement(this.props.strategy);
      const followingStrategy = await followStrategyRequest(this.props.strategy.id);
      const followingPicks = await getPicksRequest();
      const payments = await getUserPaymentsRequest();
      this.props.followStrategy(followingStrategy, this.props.strategy.subsAmount);
      this.props.setFollowingPicks(followingPicks);
      this.props.setUserPayments(payments);
      this.setState({loading: false});
    } catch (e) {
      this.setState({loading: false});
      console.error(e);
      // TODO handle error
    }
  }

  async unfollowStrategy() {
    if (window.confirm('Are you sure you want to unfollow the strategy and all associated picks?')) {
      try {
        this.props.onSubsAmountDecrement && this.props.onSubsAmountDecrement(this.props.strategy);
        await unfollowStrategyRequest(this.props.strategy.id);
        this.props.unfollowStrategy(this.props.strategy.id);
      } catch (e) {
        console.error(e);
        // TODO handle error
      }
    }
  }

  async followAction() {
    const {Paddle} = window;
    const {strategy} = this.props;

    try {
      const {url} = await getPaymentLinkRequest(this.source, strategy.id);

      Paddle.Checkout.open({
        successCallback: async () => {
          await this.followStrategy(strategy);
          alert('Congratulations! You started to follow Premium strategy!');
        },
        closeCallback: () => this.setState({loading: false}),
        override: url,
      });
    } catch (err) {
      console.error(err);
    }
  }

  render() {
    const {loading} = this.state;
    const {isFollowing, strategy, payments} = this.props;
    const isPurchased = payments.some(
      str => str.strategyId === (strategy.strategyId ? strategy.strategyId : strategy.id),
    );
    const followText = isPurchased ? 'Follow' : `Follow for ${strategyPrice(strategy.price)}`;

    return (
      <div className="follow-strategy">
        <button
          type="button"
          disabled={loading}
          onClick={this.handleClick}
          className={classnames('follow-strategy-button', !isFollowing && 'paddle_button')}
        >
          {isFollowing ? (
            <UnfollowIcon color={loading ? '#888888' : '#FF4900'} />
          ) : (
            <FollowIcon color={loading ? '#888888' : '#FF4900'} />
          )}
          {/* eslint-disable-next-line no-nested-ternary */}
          {isFollowing ? 'Unfollow' : followText}
        </button>
      </div>
    );
  }
}

export default connect(
  (state, props) => ({
    isFollowing: checkStrategyIsFollowing(props.strategy.id)(state),
    payments: getUserPayments(state),
  }),
  dispatch => ({
    followStrategy: (strategy, subsAmount) => dispatch(followStrategy(strategy, subsAmount)),
    unfollowStrategy: strategyId => dispatch(unfollowStrategy(strategyId)),
    setFollowingPicks: followingPicks => dispatch(setFollowingPicks(followingPicks)),
    setUserPayments: payments => dispatch(setUserPayments(payments)),
  }),
)(FollowStrategy);
